var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-container"},_vm._l((_vm.items),function(item,index){return _c('RouterLink',{key:index,staticClass:"item",class:{ active: _vm.isActive(item) },attrs:{"exact":item.exact,"to":{name:item.name}}},[_c('Icon',{attrs:{"type":item.icon}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(item.title))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }